import axiosInstance from "auth/FetchInterceptor";
import { MARKETING_SETTING_API } from "constants/ApiConstant";
const MarketingSettingService = {};

MarketingSettingService.searchHinhThuc = function (data) {
    return axiosInstance.post(`${MARKETING_SETTING_API}/search-hinh-thuc`, data, {
        baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
    });
};

MarketingSettingService.getDefaultHinhThuc = function (data) {
    return axiosInstance.get(`${MARKETING_SETTING_API}/default-hinh-thuc?default=${data}`, {
        baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
    });
};

MarketingSettingService.upSertHinhThuc = function (data) {
    return axiosInstance.put(`${MARKETING_SETTING_API}/upsert-hinh-thuc`, data, {
        baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
    });
}

MarketingSettingService.deleteHinhThuc = function (id) {
    return axiosInstance.delete(`${MARKETING_SETTING_API}/delete-hinh-thuc?Id=${id}`, {
        baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
    });
};

MarketingSettingService.searchTrangThai = function (data) {
    return axiosInstance.post(`${MARKETING_SETTING_API}/search-trang-thai`, data, {
        baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
    });
};

MarketingSettingService.getDefaultTrangThai = function (data) {
    return axiosInstance.get(`${MARKETING_SETTING_API}/default-trang-thai?default=${data}`, {
        baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
    });
};

MarketingSettingService.upSertTrangThai = function (data) {
    return axiosInstance.put(`${MARKETING_SETTING_API}/upsert-trang-thai`, data, {
        baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
    });
}

MarketingSettingService.deleteTrangThai = function (id) {
    return axiosInstance.delete(`${MARKETING_SETTING_API}/delete-trang-thai?Id=${id}`, {
        baseURL: process.env.REACT_APP_CRM_ENDPOINT_URL,
    });
};
export default MarketingSettingService;
